<template>
  <div>
    <!-- <b-form-select v-model="selected" :options="options"></b-form-select> -->

    <p class="filter-title">Course</p>
    <router-link type="button" size="sm" class="button_course" v-for="course in $store.state.event.data.list_courses"
      :key="course" v-bind:class="{
        isCurrent: $store.state.event.selection.course === course,
      }" target="_self" :to="{
          name: 'Epreuve',
          query: { id: $store.state.event.id, p: course },
        }" refresh>{{ course }}</router-link>
  </div>
</template>

<script>
export default {
  components: {},


  data() {
    return {
      selected : "first",
      options : [
        { text: 'Item 1', value: 'first' },
        { text: 'Item 2', value: 'second' },
        { html: '<b>Item</b> 3', value: 'third', disabled: true },
        { text: 'Item 4' },
        { text: 'Item 5', value: { foo: 'bar', baz: true } }
      ]
    };
  },


};
</script>

<style scoped>
a.button_course{
  background-color: #f29406 ;
    color: white !important;
    padding: 0.25rem 0.5rem;
    line-height: 1.5;
    border:1px solid #f29406;
      margin: 2px;
  font-size:13px;
  border-radius:3px !important;
}
a.button_course.isCurrent{
 color:#f29406 !important;
}


.button_course a {
  color: inherit !important;
}


</style>
